import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ModalsModule } from '../../global-components/modals/modals.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzShareModule } from '../../nz/nz-share.module';
import { UIModule } from '../../ui/ui.module';

@NgModule({
  imports: [
  ],
  exports: [
    CommonModule,
    BrowserModule,
    ModalsModule,
    UIModule,
    NzShareModule,
    ReactiveFormsModule,
    NzModalModule,
  ]
})
export class SharedModule {}
